const accessibility = () => {
  const mainContent = document.getElementById('main-content')
  const jumpToContent = document.getElementById('acc-jump-to-content')

  jumpToContent && mainContent && jumpToContent.addEventListener('click', () => {

    mainContent.focus()
  })

  const links = document.querySelectorAll('.accessibility__link')

  links.length && links.forEach(link => {
    link.addEventListener('focus', e => {
      jumpToContent.classList.add('accessibility--active')
    })

    link.addEventListener('blur', e => {
      jumpToContent.classList.remove('accessibility--active')
    })

  })
}

export default accessibility